var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnBtnFlagFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICN_BTN_Flag_FR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 18,
    height: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Components---Master",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICN_BTN_Flag_FR"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICN_BTN_more"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Unknown",
    transform: "translate(5.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("image", {
    mask: "url(#mask-2)",
    x: -1,
    y: 0.4,
    width: 20,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASIAAACuCAMAAAClZfCTAAAAElBMVEUAAAD/zgDdAADnAADaAAD/2AAtsSEoAAABpElEQVR4Ae3SsRHAMAwDMclJ9l85I3znCqy/wnHGCBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIELgo8FgJzLAQQBdA5iBClQAZehCgFMvAiRCmQgRchSoEMvAhRCmTgRYhSIAMvQpQCGXgRohTIwIsQpUAGXoQoBTLwIkQpkIEXIUqBDLwIUQpk4EWIUiADL0KUAhl4EaIUyMCLEKVABl6EKAUy8CJEKZCBFyFKgQy8CFEKZOBFiFIgAy9ClAIZeBGiFMjAixClQAZehCgFMvAiRCmQwbwWAvNZCMxaCCAKoF1EiFIgAy9ClAIZeBGiFMjAixClQAZehCgFMvAiRCmQgRchSoEMvAhRCmTgRYhSIAMvQpQCGXgRohTIwIsQpUAGXoQoBTLwIkQpkIEXIUqBDLwIUQpk4EWIUiADL0KUAhl4EaIUyMCLEKVABl6EKAUy8CJEKZCBFyFKgQy8CFEKZOBFiFIgAy9ClAIZeBGiFMjAi5LoBzBkzQu/tuE6AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    mask: "url(#mask-2)",
    x: -1,
    y: 0,
    width: 20,
    height: 13,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAAFVBMVEX///8AI5XtKTkAFJJ6gbrzg4ntHTC7o1gDAAAB8klEQVR4Ae3SuQ0AMRADMfu+/kt2ARNvcAAVTkho7bHdz5rb+11jW2Mkm0ltmTCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUCLnzCpQIufMKlAi58wqUDLb39yAOSqzeE4+IUsAAAAAElFTkSuQmCC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnFlagFr);
export default __webpack_public_path__ + "static/media/ICN_BTN_Flag_FR.1e7391425746b4b3d81990a770045b2d.svg";
export { ForwardRef as ReactComponent };